import React from "react";
import { t } from "i18next";
import { Link, useLocation } from "react-router-dom";

const BottomNavigation = () => {
  const location = useLocation();
  return (
    <div className="mobile-navigator hidden-md-and-up">
      <div className="row no-gutters">
        <div className="grow col col-auto">
          <Link
            to="/refer"
            className={`v-btn v-btn--has-bg v-btn--router v-btn--tile theme--light v-size--default ${
              location?.pathname == "/refer"
                ? "link-active v-btn--active v-btn--active"
                : ""
            }`}
            style={{ height: "auto" }}
          >
            <span className="v-btn__content">
              <div className="text-center">
                <img
                  alt
                  src={`/assets/new/icon_referral${
                    location?.pathname == "/refer" ? "_active" : ""
                  }.svg`}
                  className="icon_btm_nav rebateicon"
                />
                <p>{t("Referral")}</p>
              </div>
            </span>
          </Link>
        </div>
        <div className="grow col col-auto">
          <Link
            to="/promotion"
            className={`v-btn v-btn--has-bg v-btn--router v-btn--tile theme--light v-size--default ${
              location?.pathname == "/promotion"
                ? "link-active v-btn--active v-btn--active"
                : ""
            }`}
            style={{ height: "auto" }}
          >
            <span className="v-btn__content">
              <div className="text-center">
                <img
                  alt
                  src={`/assets/new/icon_promotion${
                    location?.pathname == "/promotion" ? "_active" : ""
                  }.svg`}
                  className="icon_btm_nav"
                />
                <p>{t("Promotion")}</p>
              </div>
            </span>
          </Link>
        </div>

        <div className="grow col col-auto">
          <Link
            to="/"
            className={`v-btn v-btn--has-bg v-btn--router v-btn--tile theme--light v-size--default ${
              location?.pathname == "/"
                ? "link-active v-btn--active v-btn--active"
                : ""
            }`}
            style={{ height: "auto" }}
          >
            <span className="v-btn__content">
              <div className="text-center">
                <img
                  alt
                  src={`/assets/new/icon_home${
                    location?.pathname == "/" ? "_active" : ""
                  }.svg`}
                  className="icon_btm_nav"
                />
                <p>{t("Home")}</p>
              </div>
            </span>
          </Link>
        </div>
        <div className="grow col col-auto">
          <Link
            to="/bank/deposit"
            className={`v-btn v-btn--has-bg v-btn--router v-btn--tile theme--light v-size--default ${
              location?.pathname == "/bank/deposit"
                ? "link-active v-btn--active v-btn--active"
                : ""
            }`}
            style={{ height: "auto" }}
          >
            <span className="v-btn__content">
              <div className="text-center">
                <img
                  alt
                  src={`/assets/new/icon_bettingpass${
                    location?.pathname == "/bank/deposit" ? "_active" : ""
                  }.svg`}
                  className="icon_btm_nav"
                />
                <p>{t("Deposit")}</p>
              </div>
            </span>
          </Link>
        </div>
        <div className="grow col col-auto">
          <Link
            to="/account"
            className={`v-btn v-btn--has-bg v-btn--router v-btn--tile theme--light v-size--default ${
              location?.pathname == "/account"
                ? "link-active v-btn--active v-btn--active"
                : ""
            }`}
            style={{ height: "auto" }}
          >
            <span className="v-btn__content">
              <div className="text-center">
                <img
                  alt
                  src={`/assets/new/icon_rewards${
                    location?.pathname == "/account" ? "_active" : ""
                  }.svg`}
                  className="icon_btm_nav"
                />
                <p>{t("Account")}</p>
              </div>
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BottomNavigation;
